/*
 * Official USAF PFRA Scoring Charts (Effective 1 March 2026)
 * Source: https://www.afpc.af.mil/Portals/70/documents/FITNESS/PFRA%20Scoring%20Charts.pdf
 * Last synced: 2026-05-20
 * PLANK and RUN values are pre-converted to seconds.
 */
import type { ScoringTable } from './types'
import rawTables from '../data/pfra-scoring-charts.json'

export const PU_STD_M: ScoringTable = rawTables.PU_STD_M as ScoringTable
export const PU_STD_F: ScoringTable = rawTables.PU_STD_F as ScoringTable
export const PU_HR_M:  ScoringTable = rawTables.PU_HR_M  as ScoringTable
export const PU_HR_F:  ScoringTable = rawTables.PU_HR_F  as ScoringTable
export const SITUP_M:  ScoringTable = rawTables.SITUP_M  as ScoringTable
export const SITUP_F:  ScoringTable = rawTables.SITUP_F  as ScoringTable
export const CLRC_M:   ScoringTable = rawTables.CLRC_M   as ScoringTable
export const CLRC_F:   ScoringTable = rawTables.CLRC_F   as ScoringTable
export const PLANK_M:  ScoringTable = rawTables.PLANK_M  as ScoringTable
export const PLANK_F:  ScoringTable = rawTables.PLANK_F  as ScoringTable
export const RUN_M:    ScoringTable = rawTables.RUN_M    as ScoringTable
export const RUN_F:    ScoringTable = rawTables.RUN_F    as ScoringTable
export const HAMR_M:   ScoringTable = rawTables.HAMR_M   as ScoringTable
export const HAMR_F:   ScoringTable = rawTables.HAMR_F   as ScoringTable

export const WHTR_TABLE: [number, number][] = rawTables.WHTR_TABLE as [number, number][]
